// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"834":"e9bb2709","941":"3c48f314"}[chunkId] + ".css";
};